import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import TemplateVariableBlockChip from '../components/TemplateVariableBlockChip.tsx';
import { TEMPLATE_VARIABLE_BLOCK_ATTR } from '../templateVariableAttrs.ts';

export const TemplateVariableBlock = Node.create({
  name: 'templateVariableBlock',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      variable: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute(TEMPLATE_VARIABLE_BLOCK_ATTR),
        renderHTML: (attributes) => ({
          [TEMPLATE_VARIABLE_BLOCK_ATTR]: attributes.variable,
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: `div[${TEMPLATE_VARIABLE_BLOCK_ATTR}]` }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes), node.attrs.variable ?? ''];
  },

  addNodeView() {
    return ReactNodeViewRenderer(TemplateVariableBlockChip);
  },
});
